export enum SettingKey {
  LastMassUpdateSendingDate = 'last-mass-update-sending-date',
  IsSendingMassUpdate = 'is-sending-mass-update',
}
